export default {
  CLIENT_ID: 'f11116f2b57b4f481d95',
  REDIRECT: 'https://squarelink-inc.github.io/Sign-In-Example',
  APP_URL: 'https://app.squarelink.com',
  API_URL: 'https://api.squarelink.com'
}
